//- ==================================================
//- JavaScript: Widget
//- ==================================================

(function () {
  $(document).find('[data-mailform]').validate({
    'submitHandler': function (form) {
      var $this = $(form);
      $this.find('[type="submit"]').addClass('btn--loading');
      $.post($this.attr('action'), $this.serialize(), function (r) {
        if (r.status == true) {
          showAlert(r.message);
          $this.find('[type="submit"]').removeClass('btn--loading');
          $this[0].reset();
        }
      });
    }
  });
})();
